const willyouBeforeEach = (to, from, next) => {
    const { layout } = to.meta;
    to.meta.layout = typeof layout === "function" ? layout(to) : layout;
    next();
};

export default willyouBeforeEach;
